import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import clone from 'ramda/src/clone';
import concat from 'ramda/src/concat';
import equals from 'ramda/src/equals';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import includes from 'ramda/src/includes';
import prepend from 'ramda/src/prepend';
import uniq from 'ramda/src/uniq';
import Icon from '@components/@core/Icon';
import { SPECIALOPTIONS } from '~/services/config';

const noOp = () => {};

const Header = ({ multi = true, placeholder = 'Search...', onChange = noOp, onSelectAll = noOp }) => {
    let departments = [];
    let jobRoles = [];
    let teams = [];

    const companies = useSelector((state) => state.app.companies);
    const company = useSelector((state) => state.app.selectedCompany);
    const data = useSelector((state) => state.app.selectedEmployee);

    const currentCompanies = equals([-1], company) ? companies : company.map((e) => find((ev) => ev.id === e, companies));
    currentCompanies.forEach((item) => {
        departments = concat(item.departments || [], departments);
        jobRoles = concat(item.job_roles || [], jobRoles);
        teams = concat(item.teams || [], teams);
    });

    departments = uniq(departments);
    jobRoles = uniq(jobRoles);
    teams = uniq(teams);

    const [search, setSearch] = useState(data.search);
    const [tags, setTags] = useState({
        department_id: data.department_id || [-1],
        team_id: data.team_id || [-1],
        job_role_id: data.job_role_id || [-1],
    });
    let appDepartments = prepend({ id: SPECIALOPTIONS.ALL, name: 'All Departments' }, departments);
    let appTeams = prepend({ id: SPECIALOPTIONS.ALL, name: 'All Teams' }, teams);
    let appRoles = prepend({ id: SPECIALOPTIONS.ALL, name: 'All Roles' }, jobRoles);

    const handleChange = (key, item) => (e) => {
        if (key === 'search') {
            setSearch(e.target.value);
            onChange({ search: e.target.value, ...tags });
        } else {
            if (!item) return;
            let _tags = clone(tags);
            if (item.id === -1) _tags[key] = [-1];
            else {
                _tags[key] = filter((e) => e !== -1, _tags[key]);
                if (includes(item.id, _tags[key])) _tags[key] = filter((e) => e !== item.id, _tags[key]);
                else _tags[key].push(Number(item.id));
            }
            setTags(_tags);
            onChange({ search, ..._tags });
        }
    };

    const handleClear = () => {
        setSearch('');
        onChange({ search: '', ...tags });
    };

    const handleShowAll = () => {
        setSearch('');
        setTags({ department_id: [-1], team_id: [-1], job_role_id: [-1] });
        onChange({ search: '', department_id: [-1], team_id: [-1], job_role_id: [-1] });
    };

    return (
        <div className="p-2">
            <div className="filter-search">
                <Icon name="fas fa-search" size={18} color="#969FAA" />
                <Form.Control type="text" placeholder={placeholder} value={search} onChange={handleChange('search')} />
                <Icon name="fas fa-circle-xmark me-2" size={18} color="#969FAA" onClick={handleClear} />
            </div>
            <p className="dsl-m12 mt-3 ms-1">Filter by</p>
            <Dropdown className="filter-dropdown" drop={navigator.maxTouchPoints ? 'bottom' : 'right'}>
                <Dropdown.Toggle as="div" id="ddt">
                    Departments
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {appDepartments.map((item, index) => (
                        <Dropdown.Item key={`d${item.id}`} eventKey={index + 1} as="div" active={includes(item.id, tags.department_id)} onClick={handleChange('department_id', item)}>
                            {item.name}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>

            <Dropdown className="filter-dropdown" drop={navigator.maxTouchPoints ? 'bottom' : 'right'}>
                <Dropdown.Toggle as="div" id="fdt">
                    Teams
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {appTeams.map((item, index) => (
                        <Dropdown.Item key={`t${item.id}`} eventKey={index + 1} as="div" active={includes(item.id, tags.team_id)} onClick={handleChange('team_id', item)}>
                            {item.name}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>

            <Dropdown className="filter-dropdown mb-2" drop={navigator.maxTouchPoints ? 'bottom' : 'right'}>
                <Dropdown.Toggle as="div" id="rdt">
                    Roles
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {appRoles.map((item, index) => (
                        <Dropdown.Item key={`r${item.id}`} eventKey={index + 1} as="div" active={includes(item.id, tags.job_role_id)} onClick={handleChange('job_role_id', item)}>
                            {item.name}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>

            <div className="d-flex justify-content-between border-top ps-2 py-3">
                <div className="dsl-m12 cursor-pointer" onClick={handleShowAll}>
                    Show all
                </div>
                {multi && (
                    <div className="dsl-p12 cursor-pointer" onClick={onSelectAll}>
                        Select All
                    </div>
                )}
            </div>
        </div>
    );
};

export default Header;
